import React from 'react';
import NavBar from '../components/NavBar';
import { DataGrid } from '@mui/x-data-grid';
import { CarData } from '../components/CarData';

const columns = [
  { field: 'name', headerName: 'Model', minWidth: 300, flex: 1 },
  { field: 'year', headerName: 'Yıl', width: 90 },
  { field: 'body', headerName: 'Kasa Tipi', width: 150 },
  { field: 'Cylinder', headerName: 'Motor', width: 130 },
  { field: 'price', headerName: 'Fiyat', width: 120, valueFormatter: ({ value }) => `€${Number(value).toLocaleString('tr-TR')}` },
  { field: 'Color', headerName: 'Renk', width: 100 },
];

function CarTable() {
  return (
    <div className="page-shell">
      <NavBar />
      <main className="content-shell section">
        <div className="section-heading">
          <div><p className="eyebrow">Hızlı karşılaştırma</p><h1 className="section-title">Tüm araçlar</h1></div>
          <p className="section-copy">Koleksiyondaki modelleri yıl, kasa tipi, motor ve fiyat bilgileriyle karşılaştırın.</p>
        </div>
        <div className="table-card" style={{ height: 590 }}>
          <DataGrid rows={CarData} columns={columns} disableRowSelectionOnClick
            initialState={{ pagination: { paginationModel: { page: 0, pageSize: 10 } } }}
            pageSizeOptions={[5, 10]} />
        </div>
      </main>
    </div>
  );
}

export default CarTable;
